<span class="load-event-value" [i18n]="[{target: 'innerHTML', key: 'local-loads.search.details.events.manual-item-added.message', params: { line: event.newValue }}]">
</span>
